<template>
  <div class="step-form-container">
    <!-- Progress Bar -->
    <div class="progress-bar">
      <div class="progress-bar-inner" :style="`width: ${(currentStep / totalSteps) * 100}%`"></div>
    </div>
    <!-- Step Content with Fade Out Then Fade In Effect -->
    <transition :name="transitionName" mode="out-in">
      <div :key="currentStep" class="step-content">
        <!-- Step 1 -->
        <div v-if="currentStep === 1">
          <template>
            <div class="text-center">
               <h2>Election Type</h2>
            </div>
            <v-radio-group v-model="electionType" row class="justify-center myradio">
              <div class="makeseperate">
                <div class="halfscreen">
                  <v-img :src=privateimg contain height="100" class="mb-2" />
                  <v-radio :value="'private'" class="d-block mx-auto" hide-details label=""></v-radio>
                  <div class="caption">Club / Business</div>
                </div>
                <div class="halfscreen">
                  <v-img :src=governmentimg contain height="100" class="mb-2"/>
                  <v-radio :value="'government'" class="d-block mx-auto" hide-details label=""></v-radio>
                  <div class="caption">Government / Council</div>
                </div>
              </div>
            </v-radio-group>
            <div class="errorclass text-center" v-if="error.electionType">{{ error.electionType }}</div>
          </template>
        </div> 
        <div v-if="currentStep === 2">
          <div class="text-center"><h2>Election Information</h2></div>
          <div class="first-part" >
            <div class="myrows">
              <div><v-select :items="countries" item-text="name" label=" Country" v-model="country" hide-details  disabled  solo></v-select></div>
              <div><v-select :items="timezoneList" item-text="name" label=" Timezone" v-model="timezone" hide-details solo></v-select></div>
            </div>
            <div class="myrows">
              <div class="">
                <date-pick class="dobpicker" :format="'DD/MM/YYYY'"  :isDateDisabled="isFutureDate" v-model="electionstartdate">
                  <template v-slot:default="{toggle}">
                    <v-text-field  
                      hide-details 
                      solo  
                      label="Start Date" 
                      @click="toggle" placeholder="DD/MM/YYYY" v-model="electionstartdate">
                    </v-text-field>
                   </template>
                 </date-pick>
                 <div class="errorclass txtleft" v-if="error.electionstartdate">{{ error.electionstartdate }}</div>
             </div>
             <div class="">
                <date-pick class="dobpicker" :format="'DD/MM/YYYY'" :isDateDisabled="isFutureDate" v-model="electionenddate">
                  <template v-slot:default="{toggle}">
                    <v-text-field  hide-details solo  label="End Date" @click="toggle" placeholder="DD/MM/YYYY" v-model="electionenddate">
                    </v-text-field>
                   </template>
                 </date-pick>
             </div>
            </div>    
            <div class="myrows">
              <div class="">
                <div class="inner-inner-flex">
                  <div>Start Time</div>
                  <div><vue-timepicker v-model="starttime" format="hh:mm A"></vue-timepicker></div>
                </div>
                <div class="errorclass txtleft" v-if="error.electionstarttime">{{ error.electionstarttime }}</div>
             </div>
             <div class="">
              <div class="inner-inner-flex">
                <div>End Time</div>
                <div><vue-timepicker v-model="endtime" format="hh:mm A"></vue-timepicker></div>
              </div>  
                <div class="errorclass txtleft" v-if="error.electionendtime">{{ error.electionendtime }}</div>
             </div>
            </div>
        </div>
        </div>  
        <!-- Step 2 -->
        <div v-if="currentStep === 3">
          <div class="text-center"><h2>Election Template</h2></div>
          <v-expansion-panels  v-model="expandedPanel" class="myexpansion" >
            <v-expansion-panel>
              <v-expansion-panel-header> Default Template </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="template-imgs">
                 <div class="temp-img-wrapper">
                  <div class="temp-img" @click="showtemplate('template1','template1.png','static','')" :class="{ 'clicked': template == 'template1' }">
                    <img src="../assets/voting-template-1.png" @click="showtemplate('template1','template1.png','static','','../assets/voting-template-1.png')" />
                  </div>
                  <div>Form with Photos/Logos</div>
                </div> 
                <div class="temp-img-wrapper">
                  <div class="temp-img" @click="showtemplate('template2','template2.png','static','')" :class="{ 'clicked': template == 'template2' }">
                    <img src="../assets/voter-template-2.png" @click="showtemplate('template2','template2.png','static','','../assets/voter-template-2.png')" />
                  </div>  
                  <div>Regular Form</div>
                </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <template v-if="mytemplates.length == 0">
            <v-expansion-panel >
              <v-expansion-panel-header>My templates</v-expansion-panel-header>
              <v-expansion-panel-content>  </v-expansion-panel-content>
            </v-expansion-panel>
          </template> 
            <template v-else> 
              <v-expansion-panel v-for="(val,key) in mytemplates" :key="key">
                <v-expansion-panel-header   @click="onHeaderClick(val)">{{ val.template_name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="template-imgs">
                    <div class="temp-img-wrapper">
                      <div class="temp-img" @click="showtemplate(val.template, val.template_image, 'dynamic', val)" 
                           :class="{ 'clicked': template == val.template }">
                        <img :src="val.template_image" @click="showtemplate(val.template, val.template_image, 'dynamic', val,val.template_image)" />
                      </div>
                      <!-- Delete Button Inside the Container -->
                      <span class="material-icons deletebtn" @click="deletetemplate(val.template_id)">delete</span>
                    </div>
                  </div>
                  
                </v-expansion-panel-content>
              </v-expansion-panel>
            </template>
          </v-expansion-panels>
          
          <div class="errorclass text-center mt-3" v-if="choosemsg != ''">{{ choosemsg }}</div>
        </div>
        <!-- Step 3 -->
        <div v-if="currentStep === 4">
          <div class="mt-5 text-center">
             <div><h2 class="removemg">Party logos or Candidate photos</h2></div>
          </div> 
          <div class=" mt-5">
            <div class="text-center">
              <div class="upload-area" @click="triggerFileUpload" @dragover.prevent="dragOver = true" @dragleave.prevent="dragOver = false" @drop.prevent="handleFileDrop" :class="{ 'drag-over': dragOver }">
              <input type="file" ref="fileInput" @change="handlePartyLogos" style="display: none" multiple />
              <p v-if="!dragOver">Click or drag and drop to upload</p>
              <p v-else-if="dragOver">Drop the file here</p>
              <p v-if="partlogoerror" class="error">{{ partlogoerror }}</p>
              </div>
           </div> 
           <div class="text-center smallfont">(choose mulitple photos of the party or logos required)</div>
           <div class="errorclass text-center" v-if="partlogoerror != ''">{{ partlogoerror }}</div>
         </div>
         <div class="myrowimgs mt-5" v-if="imageUrls.length > 0">
           <div v-for="(url, index) in imageUrls" :key="index" style="margin: 5px; position:relative" >
             <img :src="url" alt="Image Preview" width="50">
             <button class="delete-btn" @click.stop="deleteImage(index)">✖</button>
           </div>
          </div>
        </div>
        <!-- Step 4 -->
        <div v-if="currentStep === 5">
          <div class="text-center">
             <h2>Election Details</h2>
          </div>
          <div >
            <Template1 v-if="template == 'template1'" :makedisable=customtemplate :previewdata=childdata ref="template1" :preview=false  :showresult=true :fields=true :votetype=votetype :electiontype=electionType />
            <Template2 v-if="template == 'template2'" :makedisable=customtemplate :previewdata=childdata ref="template2" :preview=false :showresult=true :fields=true :votetype=votetype :electiontype=electionType />
         </div>
         <div class="myrow" v-if="customtemplate"><!---->
          <div>Upload Candidates</div>
          <div class="secondchild difflex">
            <div class="makeborder" @click="triggerFileSelect">
              <label for="myFile" class="file-label">Choose File</label>
              <span v-if="fileName">
                {{ truncatedFileName }}
              </span>
              <input style="display: none;"  type="file" @change="handleCandidate($event)"  ref="candidateInput" />
              <div class="errorclass" v-if="candidateerror">{{ candidateerror }}</div>
           </div>
           <div class="text-center smtext"><a :href="getFile()" target="_blank">Download sample file</a></div>
          </div>
       </div>
       <div class="text-center"  v-if="customtemplate"><v-btn class="mb-2 red white--text" v-if="showResetBtn" @click="resetCandidatePreview">Reset</v-btn></div>
      
       <div class="myrow makedif">
         <div>Bottom Note</div>
         <div>
         <!--
           <v-text-field 
            outlined 
            :disabled="this.disableinputs.bottomNotes"  
            @input="checkLimit" 
            ref="bottomNotes"
            v-model="childdata['note']" 
            hide-details ></v-text-field>
          -->
             <v-textarea
  v-model="childdata['note']" 
  outlined
  auto-grow
  :counter="50"
  maxlength="50"
    :disabled="this.disableinputs.bottomNotes"  
   rows="3"
   label="Bottom Note"
  :error="(childdata['note'] || '').length > 50"
  :error-messages="(childdata['note'] || '').length > 50 ? ['Max 50 characters allowed'] : []"
   @input="checkLimit"
/>
        </div>
      </div>
      <div class="myrow makedif">
         <div>Ballot Paper Color</div>
         <div>
            <vue-color-picker v-if="!this.disableinputs.ballotColor" v-model="childdata['color']" />
            <div v-else class="defaultpicker" :style="{ backgroundColor: childdata['color'] }"></div>
         </div>
      </div>
      <div class="myrow makedif">
       <div>Vote Type</div>
       <div>
         <v-radio-group v-model="votetype" @change="checkWhichVoteType" :disabled="this.disableinputs.votetype">
           <v-radio label="Number (For multiple voting 1-100)" value="Number"></v-radio>
           <v-radio label="Number To (For voting to specific number)" value="Numberto"></v-radio>
           <v-radio label="Color  (For single voting)" value="Color"></v-radio>
           <v-radio label="Cross  (For single voting)" value="Cross"></v-radio>
         </v-radio-group>
       </div>
     </div>
     <div ref="scrollToElement" class="text-center red--text">{{ commonerror }}</div>
   </div>
   <div v-if="currentStep === 6">
     <div class="mt-5">
       <div v-if="votersfile == ''">
         <div class="mt-5 text-center"><h4 class="makemebig">Upload Voters</h4></div> 
         <div class="text-center">
           <div class="upload-area-voters" @click="triggerVoterUpload" @dragover.prevent="dragOver = true" @dragleave.prevent="dragOver = false" @drop.prevent="handleVotersFileDrop" :class="{ 'drag-over': dragOver }">
               <input type="file" ref="voterInput" @change="handleVoters" style="display: none" />
                 <p v-if="!dragOver">Click or drag and drop to upload</p>
                 <p v-else-if="dragOver">Drop the file here</p>
                 <p v-if="partlogoerror" class="error">{{ partlogoerror }}</p>
           </div>
         </div> 
         <div class="text-center">(Please upload xlsx/csv format only)</div>
       </div>
       <div v-if="identities.length > 0 && jobId == 0">
         <div class="text-center">
           <div class="mt-5 text-center"><h4>Choose Identities</h4></div> 
           <div class="text-center">({{ identitychoosemsg }})</div>
         </div>  
         <div>
           <div class="identitieslist">
             <div v-for="(item,key) in identities" :key="key">
                <v-checkbox 
                   v-model="identitiesselected" 
                   :disabled="isDefaultField(item)"
                   :label=item 
                   :value=item 
                   hide-details 
                   class="diffchecks"></v-checkbox> 
             </div>
           </div>
           <div class="errorclass" v-if="error.identitiesselected">{{ error.identitiesselected }}</div>
         </div>
       </div>
     <div v-if="duplicateData.length > 0" class="mt-5 pb-5">
  <div class="red--text mb-3">
    Please see the duplicate data that shows the exact same in every field. Please change this data and resubmit
  </div>

  <!-- Header Row -->
  <div class="d-flex font-weight-bold mb-2" style="gap: 1rem;">
    <div v-for="(item, key) in duplicateDataHeader" :key="key" style="min-width: 120px;">
      {{ item }}
    </div>
  </div>

  <!-- Data Rows -->
  <div v-for="(item, key) in duplicateData" :key="key" class="d-flex mb-1" style="gap: 1rem;">
    <div v-for="(item1, key1) in item" :key="key1" style="min-width: 120px;">
      {{ item1 }}
    </div>
  </div>
</div>

       <div class="errorclass text-center" v-if="voterserror != ''">{{ voterserror }}</div> 
     </div>
   </div>  
   <!-- Step Navigation Buttons -->
   <div class="buttons" v-if="currentStep < 6">
      <v-btn color="orange" class="white--text mr-5" type="submit" @click="prevStep" :disabled="currentStep === 1">Back</v-btn>
      <v-btn color="green" class="white--text" type="submit" @click="nextStep" :disabled="makeitdisable">Next</v-btn>
   </div>
   <!---->
   <div v-if="jobId > 0" class="mt-10 prgbar">
        {{ Progressmsg }} 
       <v-progress-linear :value="uploadprogressvalue"  :active="uploadprogressvalue < 100" height="25" color="primary">
        <template v-slot:default>
          {{ uploadprogressvalue }}%
        </template>
       </v-progress-linear>
   </div>
   <div class="text-center mt-5" v-if="currentStep == 6 && votersfile != '' && identities.length > 0">
       <v-btn color="orange" class="white--text mr-5"  :disabled="makeitdisable" @click="clearAllVoterdata">Clear</v-btn>
       <v-btn color="primary" class="white--text" type="submit" @click="uploadVoters" :disabled="makeitdisable">Submit</v-btn>
   </div>  
   <v-progress-linear v-if="showProgress" :value="progress" height="6" color="blue" class="custom-progress"></v-progress-linear>
 </div>
</transition>
   <div class="sidebarnew" v-if="showsidebar">
      <template v-for="(val,key) in tempdata" >
        <div :key = key >
         <Template1 v-if="template == 'template1'" @child-mounted="onChildMounted" :showimage=true :customStyles="childStyles" :preview=true :previewdata=val :showresult=true :vote=false :votetype=votetype  />
         <Template2 v-if="template == 'template2'" @child-mounted="onChildMounted" :showimage=true :customStyles="childStyles" :preview=true :previewdata=val :showresult=true :vote=false  :votetype=votetype  />
       </div>
     </template>
   </div>
   <div class="sidebarnewright" v-if="showsiderbarother">
      <h3 class="text-center mb-3 redtext">Missing Photos / Logo</h3>             
      <template v-for="(val,key) in missingimages" >
        <div :key = key class="redtext">{{ val }}</div>
      </template>
      <h3 class="text-center mt-5 mb-3">Suggested Files</h3>             
      <template v-for="val in suggestedmatches" >
        <div v-for="(vals,keys) in val" :key = keys >{{ vals }}</div>
      </template>
    </div>
    <Popup v-if="isPopupOpen" @close="closePopup">
      <Template1 v-if="template == 'template1'" @child-mounted="onChildMounted" :customStyles="childStyles" :preview=true :previewdata=childdata :showresult=true :vote=false :votetype=votetype />
      <Template2 v-if="template == 'template2'" @child-mounted="onChildMounted" :customStyles="childStyles" :preview=true :previewdata=childdata :showresult=true :vote=false :votetype=votetype />
      <div class="saveTemplate" v-if="saveAsTemplate">
        <v-text-field outlined :disabled=maketemplatenamedisable label="Name of template" v-model="templatename" hide-details ></v-text-field>
        <div v-if="templateError != ''" class="errorclass">{{ templateError }}</div>
        <div class="mt-3">
          <v-btn type="button" :disabled="makeitdisable" @click="savetemplate" class="white--text" color="green">Save Template</v-btn>   
        </div>
      </div>
      <div class="saveTemplate" v-if="notchooseTemplate">
          {{ choosemsg }}
      </div>
    </Popup>
    <v-dialog v-model="confirmdialog" persistent max-width="320">
      <v-card v-if="showdelbtns">
        <v-card-title class="small-text"> You want to delete this template ? </v-card-title>
        <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="red darken-1" text @click="confirmdialog = false">No</v-btn>
           <v-btn color="green darken-1" text @click="confirmdelete">Yes</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
         <div class="pt-5 pb-5 text-center">
           {{ wrongmsg }}
         </div>
      </v-card>
   </v-dialog>
    <v-dialog v-model="shownumberblock" persistent max-width="320">
     <v-card>
      <v-toolbar color="primary" dark>Enter Number</v-toolbar>
      <v-card-text>
        <div class="text-center red--text mt-5">
          <v-text-field  type="number" :min="1" hide-details  solo v-model="numberrange"></v-text-field>
        </div>  
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="green darken-1" class="white--text mr-4" @click="shownumberblock = false">Submit</v-btn>
        <v-btn color="red darken-1" class="white--text" @click="shownumberblock = false">Close</v-btn>
      </v-card-actions>
  </v-card>
   </v-dialog>
   <v-dialog  persistent max-width="300" v-model="loader">
    <v-card>
      <div>
       <!--
         <div class="text-center">Please wait...</div> 
        <v-progress-linear indeterminate color="secondary"></v-progress-linear>
        -->
        <v-progress-linear
        v-model="progress"
        color="primary"
        height="25"
         class="non-clickable text-white"
      >
      <template v-slot:default="{ value }">
        <strong>{{ Math.ceil(value) }}%</strong>
      </template>
       
      </v-progress-linear>
      </div>
       
    </v-card>
  </v-dialog>
  <v-dialog   width="350" v-model="popupmodal"  >
    <v-card>
      <v-toolbar
      color="primary"
      dark
    >Alert</v-toolbar>
      <v-card-text>
        <div class="text-center red--text mt-5">{{ popupmsg}}</div>  
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="popupmodal = false"
        >Close</v-btn>
      </v-card-actions>
  </v-card>
</v-dialog>
 <v-dialog v-model="imgdialog" max-width="320">
      <v-card flat tile>
        <img
          :src="imgsrc"
          class="img-fluid"
        />
      </v-card>
    </v-dialog>
 <v-snackbar v-model="showLimitWarning" timeout="2000" color="red">
      Max 50 characters allowed
    </v-snackbar>
  </div>
</template>

<script>
import Vue from 'vue';
//import axios from 'axios'
//import VueAxios from 'vue-axios';
import DatePick from 'vue-date-pick';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Popup from "../components/Popup.vue";
import Template1 from '../Templates/Template1.vue';
import Template2 from '../Templates/Template2.vue';
import html2canvas from 'html2canvas';


export default {
  components: { VueTimepicker,DatePick,Popup, Template1, Template2},
  data() {
    return {
      transitionName: 'fade', 
      currentStep: 1,
      totalSteps: 6,  
      numberrange:2,
      showCustomButton: false,
      notchooseTemplate: false,
      makeitdisable:false,
      dragOver: false,
      showProgress:false,
      isPopupOpen: false,
      hidefornow:false,
      maketemplatenamedisable:false,
      customtemplate:false,
      confirmdialog:false,
      showdelbtns:true, 
      showsidebar:false,
      showsiderbarother:false,
      showResetBtn: false,
      expandedPanel: null,
      loader:false,
      popupmodal:false,
      shownumberblock:false,
      imgdialog:false,
      popupmsg:'',
      imgsrc:'',
      data:[],
      timezoneList:[],
      items:[],
      mytemplates:[],
      selectedFiles: [],
      imageUrls: [],
      tempdata:[],
      identitiesselected:[],
      identities:[],
      missingimages:[],
      suggestedmatches:[],
      autoSelectedIdentities: [],
      duplicateData:[],
      duplicateDataHeader:[],

      childStyles:{},
      htmlContent: null,
      interval: null,
      uploadprogressvalue:50,
      election_trans:0,
      formerror:0,
      progress:0,
      uploadprogress:0,
      jobId:0,
      jobIdOther:0,
      jobProcessId:0,
      is_demo:0,
      
      Progressmsg:'',
      identitychoosemsg:'Please select at least two identity',
      fileName:'',
      privateimg:require('@/assets/private.png'),
      governmentimg:require('@/assets/goverment.png'),
      commonerror:'',
      electionType:'',
      votersfile:'',
      voterserror:'',
      choosemsg:'',
      timezone:'',
      country:'',
      electionstartdate:'',
      electionenddate:'',
      starttime:'',
      endtime:'',
      templateError:'',
      defaultcolor:'#EEF6E7',
      template:'',
      partlogoerror:'',
      wrongmsg:'',
      candidateerror:'',
      votetype:'Number',
      countries:["America", "Australia", "United Kingdom","New Zeland"],
      error:{'electionType':'','electionstartdate':'','electionstarttime':'','electionendtime':'','candidates':'','voters':'','identitiesselected':''},
      disableinputs:{'bottomNotes':false,'ballotColor':false, 'votetype':false},
      childdata : {
          candidates: [
            { image: "unknown.png", lastname: "Doe", firstname: "John", designation: "Unknown Party" },
            { image: "women.png", lastname: "Pankhurst", firstname: "Emmeline", designation: "Women’s Social Party" },
            { image: "pirate.png", lastname: "Kidd", firstname: "William", designation: "Pirate Party" },
            { image: "united.png", lastname: "Beckham", firstname: "David", designation: "United Party" },
            { image: "nurses.png", lastname: "Nightingale", firstname: "Florence", designation: "Nurses Party" }
          ]
        },
      showLimitWarning: false,  
    };
  },
  computed: {
    truncatedFileName() {
      if (!this.fileName) return '';
      const maxLength = 15;
      const ext = this.fileName.split('.').pop();
      const nameWithoutExt = this.fileName.slice(0, -(ext.length + 1));
      if (this.fileName.length <= maxLength) return this.fileName;
      return `${nameWithoutExt.slice(0, 15)}...${ext}`;
    },
  },
  created(){
     this.$root.$refs.Electiondashboard = this;
     this.initialData();
  },
  methods: {
    checkLimit() {
      
      if (this.childdata['note'].length >= 50) {
        // Show snackbar
        if (!this.showLimitWarning) {
          this.showLimitWarning = true;
        }
   
      }
    },
    onHeaderClick(val) {
    this.selectedTemplate = val.template;
    this.showtemplate(val.template, val.template_image, 'dynamic', val);
  },
  checkWhichVoteType(){
     if(this.votetype == "Numberto")
        this.shownumberblock = true;
     else
        this.shownumberblock = false;
  },
    /**/
    initialData()
    {
      this.getMyTemplates();
      this.$store.dispatch("checkElection",{url:this.$route.params.url}).then((response) => 
      {
       if(response.status)
       {
         this.country = response.data.country;
         this.data    = response.data;
         this.items.push({  lastname: " ", firstname: "",designation: "",image: null },{  lastname: " ", firstname: "",designation: "",image: null });
         this.childdata['color'] = this.defaultcolor;
         this.is_demo = response.data.is_demo;
         this.timezoneList = response.data.timezones;
         if(typeof response.data.election_type != 'undefined'){
          this.electionType = response.data.election_type;
         }  

         if(typeof response.data.election_data.start_date != 'undefined'){
          this.electionstartdate = response.data.election_data.start_date;
         }  
         
         if(typeof response.data.election_data.end_date != 'undefined'){
          this.electionenddate = response.data.election_data.end_date;
         }  

         if(typeof response.data.election_data.start_time != 'undefined'){
          this.starttime = response.data.election_data.start_time;
         }  

         if(typeof response.data.election_data.end_time != 'undefined'){
          this.endtime = response.data.election_data.end_time;
         }  
         
         if(typeof response.data.election_data.id != 'undefined'){
           this.election_trans = response.data.election_data.id;
           this.voteruploaded = response.data.election_data.voter_uploaded;
         }  

         if(response.data.election_data.voter_uploaded == "N")
         { 
            if(response.data.candidateUploaded == 1) 
              this.currentStep = 6;
            else
              this.currentStep = 3;
         }
       }
       else{
         this.$router.push({name:'home'});
       }
     })
    },
    isFutureDate(date) {
       const currentDate = new Date();
       return date < currentDate;
    }, 
    /**/
   async nextStep() {
      if (await this.validateStep(this.currentStep)) {
        this.currentStep++;
        this.showCustomButton = this.currentStep === 3;
      }
    },
    prevStep() {
      //vikasvyas
      
      this.showsidebar = false;
      this.showsiderbarother = false;
      if (this.currentStep > 1) {
        if(this.currentStep == 5)
        {
          if(this.template == 'template2'){
            this.currentStep = 3;
          }else{
            if(this.customtemplate)
              this.currentStep = 4;
            else
              this.currentStep = 3;
          }
        }
        else
        {
          this.currentStep--;
        }
      }
    },
    async goToStep(stepNumber) {
      if (await this.validateStep(this.currentStep)) {
        this.currentStep = stepNumber;
      }
    },
    async validateStep(step) 
    {
      if(step == 1)
      {
         if(this.electionType == '') 
         {
            this.error.electionType = 'Choose election type';
            return false;
         } 
         else 
         {
            this.error.electionType = '';
            return true;
         }
      }
      else if(step == 2) 
      {
         if (this.electionstartdate == '') {
            this.error.electionstartdate = 'Select a date of election';
         } else {
            this.error.electionstartdate = '';
         }

         if (this.starttime == '') {
            this.error.electionstarttime = 'Select a start time of election';
         } else {
            this.error.electionstarttime = '';
         }

         if (this.endtime == '') {
          this.error.electionendtime = 'Select an end time of election';
         } else {
          this.error.electionendtime = '';
         }

        if (this.error.electionstartdate == '' && this.error.electionstarttime == '' && this.error.electionendtime == '' && this.election_trans == 0) 
        {
          this.loader = true;
          this.showProgress = true;
          let formData = new FormData();
          formData.append('eid', this.data.id);
          formData.append('election_trans_id', this.election_trans);
          formData.append('electionstartdate', this.electionstartdate);
          formData.append('electionenddate', this.electionenddate);
          formData.append('starttime', this.starttime);
          formData.append('endtime', this.endtime);
          formData.append('timezone', this.timezone);
          formData.append('electionType', this.electionType);
          this.makeitdisable = true;

          return new Promise((resolve) => {
              Vue.axios.post('/save-election-data', formData, {headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      },})
                .then(response => {
                  this.showProgress = false;
                  this.makeitdisable = false;
                  this.loader = false;
                  if (response.status) {
                    if (this.election_trans == 0) {
                      this.election_trans = response.data.data;
                    }
                    this.is_demo = response.data.is_demo;
                    this.formerror = 1;
                    resolve(true); // Validation successful
                  } else {
                    resolve(false); // Validation failed
                  }
                })
                .catch(error => {
                  console.log(error);
                  this.loader = false;
                  this.makeitdisable = false;
                  this.showProgress = false;
                  resolve(false); // Validation failed
                });
            });
    } 
    else 
    {
      if(this.election_trans == 0)
        return false;
      else 
        return true;
    }
      } 
      else if (step == 3) 
      {
//        console.log(this.template)
        if (this.template == '') 
        {
          this.notchooseTemplate = true;
          this.choosemsg = 'Please choose a template.';
          
          return false;
        } 
        else 
        {
          this.notchooseTemplate = false;
          this.choosemsg = '';
          if(this.template == 'template2')
          {
            this.currentStep = 5;
          }
          else
          {
             if(this.customtemplate)
               this.currentStep = 4;
             else
               this.currentStep = 5;//return true;
          }
        }
      }
      else if (step == 4)
      {
         if(this.template == 'template1')
         {
           if(this.imageUrls.length > 0)
           {
             const formData = new FormData();
             this.selectedFiles.forEach((file, index) => {
                formData.append(`image_${index}`, file);
            });
            this.loader = true; 
            try 
            {
              this.showProgress = true;
              formData.append('election_trans_id', this.election_trans);
              this.makeitdisable = true;
              return new Promise((resolve) => { 
                Vue.axios.post("/upload-party-logo", 
                   formData, 
                   {headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                  this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                },}).then((response) =>
                   {
                    this.loader = false;
                      this.makeitdisable = false;
                      this.showProgress = false;
                      if(response.status)
                      {
                        resolve(true);
                      } 
                   });
                   //this.imageUrls = []; 
                   //this.selectedFiles = [];
              });   
              
            } 
            catch (error) 
            {
              console.error("There was an error uploading the images!", error);
              this.showProgress = false;
              this.loader = false;
            }
           } 
           else
           {
             
             this.partlogoerror = 'Please upload candidate party / logo';
           }
        }  
        else
        {
           return true;
        }   
     }
     else if(step == 5)
     {
       var noerrorhere = ''; 
       this.error.candidates = '';
       this.commonerror = '';
       if(this.customtemplate && this.dynamictemplateData.master > 0)
       {
         for(var i = 0; i < this.items.length; i++)
         {
           if(this.items[i].firstname == '' || this.items[i].lastname == '')
           {
             noerrorhere = 'error';
           }
        }
        }

      var electionTypeError = 0;
      if(!this.customtemplate)
      {
        if(this.votetype == 'Numberto' && (this.numberrange < 2 || this.numberrange == ''))
        {
          noerrorhere = 'error';
          electionTypeError = 1;
        }
        
      }
      if(noerrorhere == '')
      {
         this.saveAsTemplate = true;
         this.previewTemplate();
      }
      else
      {
        if(electionTypeError == 1)
        {
          this.commonerror = 'Please enter a valid number';
        }
        else
        {
          this.error.candidates = 'Please provide at least 2 candidates details';
          this.$refs.scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        
      }
     }
  return false;
    },
    closePopup() {
      this.isPopupOpen = false;
      this.saveAsTemplate = false;
    },
    previewTemplate(){
    
    if(this.saveAsTemplate)
      this.childStyles = this.getStyle();
    else
      this.childStyles = {};
   
    return new Promise(resolve => 
         {
            let childComponent = '';
            if(this.template == 'template1')
            {
              childComponent = this.$refs.template1;  
            }
            else if(this.template == 'template2')
            {
              childComponent = this.$refs.template2;  
            }

            childComponent.$on('child-data', data => {
              resolve(data);
            });
            
            childComponent.sendDataToParent(); // Trigger sending data from child
          }).then(data => 
            {
            this.childdata['data'] = data;
            if(this.customtemplate)
            {
              if(this.tempdata.length > 0)
              {
                 this.saveForm();
              } 
              else
              {
                 this.showloadingmsg = false;
                 this.showerrorgmsg = true;
                 this.message = "Please upload candidates";
                 setTimeout(() => { 
                  this.showerrorgmsg = false;
                  this.message = '';
                 }, 1500);
              }
            }
            else
            {
              this.isPopupOpen = true;
            }
          });
    },
    getStyle(){
      return {position: 'absolute', left: '-9999px'}
    },
    saveForm()
    {
      let formData        = new FormData();
      this.makeitdisable = true;
      formData.append('eid',this.data.id);
      formData.append('election_trans',this.election_trans);
      formData.append('master_template',this.dynamictemplateData.template_id);
      formData.append('candidates', this.tempfile);
      Vue.axios.post('/create-template-copy',formData,{headers: {'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      },
    }).then(response => 
      {
        
        if(response.data.status)
        {
          this.makeitdisable = false;
          this.showProgress = false;
          this.jobIdOther = response.data.job_id;
          this.startPollingCandidate();
          this.loader = true
          this.progress = 0;
          this.showProgress = true;
           //this.showsidebar = false;
           //this.showsiderbarother = false;
           //this.currentStep = 6;
           //this.loader = false;
          //comehere
        }
        else
        {
          alert(response.data.msg);
         
          this.makeitdisable = false;
        } 
      });   
    },
    startPollingCandidate() {

      this.interval = setInterval(() => {
        if (!this.jobIdOther) return;

        Vue.axios.get(`/candidate-progress/${this.jobIdOther}`).then(res => {
          if (res.data) {
            this.progress = res.data.progress;
            if (res.data.status === 'completed') 
            {
              this.showProgress = false;
              this.loader = false;
              this.showsidebar = false;
              this.showsiderbarother = false;
              
              clearInterval(this.interval);
              this.currentStep = 6;
            }
          }
        });
      }, 2000);
    },
    gotoTop(){
      this.$refs.scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    onChildMounted(childElement) {
      this.htmlContent = childElement;
    },
    getMyTemplates(){
      this.$store.dispatch("getmyTemplates").then((response) => { this.mytemplates = response.data;   });
    },
    showtemplate(template,src,type,customdata,mysrc=""){
      this.template = template;
      this.childdata['color'] = this.defaultcolor;
      if(type == 'static')
      { 
         this.customtemplate = false;
         this.imgsrc   = require('../assets/'+src);
         if(mysrc != '')
         {
          this.imgdialog = true;
         }
         this.childdata['data'] = [];
         this.childdata['note']  = '';
         this.dynamictemplateData = {};
         this.templatename = '';
         this.maketemplatenamedisable = false;
         this.items = [{  lastname: " ", firstname: "",designation: "",image: null },{  lastname: " ", firstname: "",designation: "",image: null }];
         Object.keys(this.disableinputs).forEach(key => { this.disableinputs[key] = false; });
      }
      else
      { 
         this.imgsrc   = src;
         if(mysrc != '')
         {
          this.imgdialog = true;
         }
         this.customtemplate = true;
         this.dynamictemplateData = customdata;
         
         if(customdata.master > 0){ 
           this.maketemplatenamedisable = true;
           this.templatename = this.dynamictemplateData.template_name;
         } else{
           this.maketemplatenamedisable = false;
           this.templatename = '';
         } 
         
         Object.keys(this.disableinputs).forEach(key => { this.disableinputs[key] = true; });
         
         if(typeof customdata.data.vote_type != 'undefined'){
           this.votetype = customdata.data.vote_type;
         }
         if(typeof customdata.data.data != 'undefined'){
           this.childdata['data'] = customdata.data.data;
         }
         if(typeof customdata.data.color != 'undefined'){
           this.childdata['color'] = customdata.data.color;
         }
         if(typeof customdata.data.note != 'undefined'){
           this.childdata['note'] = customdata.data.note;
         }
         if(typeof customdata.candidates != 'undefined'){
           if(customdata.candidates.length > 0){ 
               this.items = customdata.candidates;
               this.childdata['candidates'] = customdata.candidates;
           }
           else{
              this.items = [{  lastname: " ", firstname: "",designation: "",image: null },{  lastname: " ", firstname: "",designation: "",image: null }];
            } 
         }
         //this.childdata['color'],'data':this.childdata['data'],'note':this.childdata['note']
         
       }
    },
    getFile(){
      if(this.electionType == 'private')
      {
         if(this.template == "template1")
          return process.env.VUE_APP_BASEURL+"private-format1";
        else
          return process.env.VUE_APP_BASEURL+"private-format2";  
      } 
      else
      {
         if(this.template == "template1")
          return process.env.VUE_APP_BASEURL+"format1";
        else
          return process.env.VUE_APP_BASEURL+"format2";  
      }
    },
    deleteImage(index) {
      this.imageUrls.splice(index, 1); // Remove the image at the specified index
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handlePartyLogos(event) {
      this.addFiles(event.target.files);
    },
    handleFileDrop(event) {
      this.dragOver = false;
      this.addFiles(event.dataTransfer.files);
    },
    addFiles(selectedFiles) {
      const allowedExtensions = ["jpg", "jpeg", "png", "gif"]; // Allowed image formats
      this.partlogoerror = ""; // Clear any previous errors

      Array.from(selectedFiles).forEach((file) => {
        const extension = file.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(extension)) {
          // Add file to selectedFiles for backend processing
          this.selectedFiles.push(file);
          // Generate preview URL and add to imageUrls
          this.imageUrls.push(URL.createObjectURL(file));
        } else {
          this.partlogoerror = "Please upload only image files (jpg, jpeg, png, gif)";
        }
      });
    },
    skipStep(stepNumber) {
      if (this.validateStep(this.currentStep)) {
        this.currentStep = stepNumber;
      }
    },
    customButtonAction() {
      alert('Custom action triggered!');
    },
    savetemplate() 
    {
      if (this.htmlContent) {
    html2canvas(this.htmlContent, {
      useCORS: true,
      logging: false,
      allowTaint: true,
      scale: 2, // Improves image clarity
    }).then(canvas => {
      // Create a new canvas with an increased height
      const resizedCanvas = document.createElement('canvas');
      const ctx = resizedCanvas.getContext('2d');
      resizedCanvas.width = 355;
      resizedCanvas.height = 380; // Increased height to avoid stretching

      // Draw the original captured canvas onto the resized one
      ctx.drawImage(canvas, 0, 0, 355, 380);

      // Convert to an image
      const image = resizedCanvas.toDataURL('image/png');

      if (this.templatename !== '') {
        this.saveImageToServer(image);
      } else {
        this.templateError = 'Please provide a name for the template';
      }
    });
  } else {
    console.error('Child component not mounted yet.');
  }
},
    saveImageToServer(imageData) 
    {
        let myheading2 = '';
        let myheading3 = '';
        if(typeof this.childdata['data'].heading2 == "undefined")
          myheading2 = '';
        else
          myheading2 = this.childdata['data'].heading2;

        if(typeof this.childdata['data'].heading3 == "undefined")
          myheading3 = '';
        else
          myheading3 = this.childdata['data'].heading3;  

        this.makeitdisable = true;
        let customdata = {
          'color':this.childdata['color'],
          'data':{
                   'heading2':myheading2,
                   'heading3':myheading3,
                   'topheading':this.childdata['data'].topheading
                 },
          'note':this.childdata['note']
        };
       
       var templateid = 0; 
       var master     = 0;
       if(this.customtemplate) //it means that edit data
       {
          templateid = this.dynamictemplateData.template_id;
          master     = this.dynamictemplateData.master;
       }     
       
       let formData = new FormData();
       formData.append('candidates', JSON.stringify(this.items));
       formData.append('template', this.template);
       formData.append('template_data', JSON.stringify(customdata));
       formData.append('templateName', this.templatename);
       formData.append('eid', this.data.id);
       formData.append('election_trans_id', this.election_trans);
       formData.append('imageData', imageData);
       formData.append('votetype', this.votetype);
       formData.append('template_id', templateid);
       formData.append('master', master);
       formData.append('headerlogo1',this.childdata['data'].headerlogo1);
       formData.append('headerlogo2',this.childdata['data'].headerlogo2);
       if(this.votetype == 'Numberto')
       {
         formData.append('numberrange', this.numberrange);
       }
       Vue.axios.post('/save-template-data', 
                      formData, 
                      { 
                        headers: {'Content-Type': 'multipart/form-data' },
                        onUploadProgress: (progressEvent) => {
        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      },
                      }).then(response => 
                      {
                        if(response.status)
                        {
                          window.location.reload();
                        }
                      }).catch(error => {
                          console.log(error);
                          this.makeitdisable = false;
                      })  
           
    },  
    deletetemplate(id){
      this.showdelbtns = true; 
      this.confirmdialog = true;
      this.deleteTemplate = id;
    },
    confirmdelete(){
      this.$store.dispatch("deleteTemplate",{id:this.deleteTemplate}).then((response) => 
       {
          if(response.status)
          {
            this.getMyTemplates();
            this.confirmdialog = false;
            this.deleteTemplate = 0;
          }
          else
          {
             this.wrongmsg = response.msg;
             this.showdelbtns = false;
             this.timeoutId = setTimeout(() => {
              this.confirmdialog = false;
             
              }, 5000);
          }
       })
    },
    resetCandidatePreview() {
  this.tempdata = [];
  this.missingimages = [];
  this.suggestedmatches = [];
  this.showsidebar = false;
  this.showsiderbarother = false;
  this.showResetBtn = false;
  this.fileName = '';
  // Reset file input so user can select same file again
  this.$refs.candidateInput.value = null;
},
     handleCandidate(event){
      const file = event.target.files[0]; 
      this.fileName = file ? file.name : '';
      this.progress = 0;
      this.candidateerror = '';
      if (file) 
      {
        if(file.size > 0)
        {
          if(file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'text/csv') 
          {
            this.showResetBtn = true;
            this.loader = true;
            this.showloadingmsg = true;
            this.showerrorgmsg = false;
            let candidates = event.target.files[0];
            let formData = new FormData();
            this.tempfile = candidates;
            formData.append('candidates', candidates);
            formData.append('election_trans',this.election_trans);
            formData.append('templateid',this.dynamictemplateData.template_id);
            Vue.axios.post('/validate-candidates',formData,{headers: {'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      },
          }).then(response => 
            {
              if(response.data.status)
              {
                 if(response.data.result.length > 0)
                {
                  this.tempdata = [];
                  for(var i = 0; i < response.data.result.length; i++)
                  {
                    let newdata = response.data.result[i];
                   
                    this.tempdata.push({
                          candidates   : newdata.candidates,
                          data         : newdata.data.data,
                          color        : newdata.data.color, 
                          note         : newdata.data.note, 
                          template_name: newdata.template_name 
                        });
                    //this.tempdata.push()
                  }
                }
               //vikasvyas
               
               this.showsidebar = true;
               this.loader = false;
               if(response.data.missing_images.length > 0)
               {
                 this.showsiderbarother = true;
                 this.missingimages = response.data.missing_images;
                 this.suggestedmatches = response.data.suggested_matches;
               }
               else
               {
                this.showsiderbarother = false;
                 this.missingimages = [];
                 this.suggestedmatches = [];
               }
              }
              else
              {
                 this.popupmodal = true;
                 this.popupmsg = response.data.msg;
              }
              this.loader = false;
            }).catch(() => {
              this.loader = false;
            }) 
          }
          else
          {
            this.candidateerror = 'Please upload only xlsx or csv file';
          }  
        }
      }      
    },
    triggerVoterUpload() {
      this.$refs.voterInput.click();
    },
    
    handleVoters(event) {
      this.duplicateData = [];
      this.duplicateDataHeader = [];
      this.uploadprogressvalue = 0;
      this.addvoter(event.target.files);
    },
    handleVotersFileDrop(event) {
      this.dragOver = false;
      this.addvoter(event.dataTransfer.files);
    },
    isDefaultField(item) {
      const normalized = item.replace(/\s+/g, '').toLowerCase();
      const defaultFields = ['firstname', 'lastname', 'name', 'fullname', 'fullname'];
      return defaultFields.includes(normalized);
    },
    addvoter(selectedFiles) {
      const file = selectedFiles[0]; 
      this.votersfile = file;
      this.voterserror = '';
      this.progress = 0;
      this.loader = true;
      if (file) 
      {
        if(file.size > 0)
        {
          if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'text/csv') 
          {
            const defaultFields = ['firstname', 'lastname', 'name', 'fullname'];
            this.showProgress = true;
            this.voters = selectedFiles[0];
            this.error.voters = '';
            let formData = new FormData();
            formData.append('voters', this.voters);
            formData.append('eid', this.data.id);
            formData.append('election_trans_id', this.election_trans);
            Vue.axios.post('/validate-file-headers', 
                              formData, 
                              { 
                                headers: {'Content-Type': 'multipart/form-data' },
                                onUploadProgress: (progressEvent) => {
                                  this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                               },
                              }).then(response => 
                              {
                                this.loader = false;
                                if(response.data.status)
                                {
                                  this.identities = response.data.data;
                                   // Set default checked and disabled values
                                  this.autoSelectedIdentities = this.identities.filter(item => {
                                      const normalized = item.replace(/\s+/g, '').toLowerCase();
                                      return defaultFields.includes(normalized);
                                   });
                                  
                                   if(this.autoSelectedIdentities.length == 1)
                                  {
                                     this.identitychoosemsg = 'Please select at least one more identity';
                                  } 
                                  if(this.autoSelectedIdentities.length == 2)
                                  {
                                     this.identitychoosemsg = 'Please select at least one more identity';
                                  } 
                                  
                                  this.identitiesselected = [...this.autoSelectedIdentities];
                                  this.showProgress = false;
                                }
                                else
                                {
                                   this.votersfile = '';
                                   this.voterserror = response.data.msg;
                                   this.showProgress = false;
                                } 
                              }).catch(() => {
                                this.showProgress = false;
                                this.loader = false;
                              })  
          } 
          else
          {
            this.error.voters = 'Please upload only xlsx or csv file';
            this.loader = false;
          }  
        }
      }
    },
    clearAllVoterdata(){
      this.identitiesselected = [];
      this.identities = [];
      this.votersfile = '';
      this.duplicateData = [];
      this.duplicateDataHeader = [];
      this.voterserror = '';
      this.showProgress = false;
      this.uploadprogressvalue = 0;
    },
    uploadVoters()
    {
       this.jobId = 0;
          if(!this.voters || this.voters == null)
          {
            this.error.voters = 'Please upload xlsx or csv file';
          }
          if(this.identitiesselected.length == 0)
          {
            this.error.identitiesselected = 'Please choose at least 2 identities';  
          }
          else
          {
            if(this.identitiesselected.length < 2)
              this.error.identitiesselected = 'Please choose at least 2 identities';  
            else
              this.error.identitiesselected = '';
          } 
          
          if (this.autoSelectedIdentities.length === 2) 
          {
             if(this.is_demo == 0)  
            {
              if (this.identitiesselected.length < 3) {
                this.error.identitiesselected = 'Please select at least 1 more identity field.';
              }
            }
          } 
          else if (this.autoSelectedIdentities.length === 1) 
          {
            if(this.is_demo == 0)  
            {
               if (this.identitiesselected.length < 2) {
              this.error.identitiesselected = 'Please select at least 1 more identity field.';
            }
            }
          
          }
          
          var noerror = 1;
          if(this.error.voters == '' && this.error.identitiesselected == '')
              noerror = 0;
          else
              noerror = 1;
         
          if(this.election_trans > 0 && this.voteruploaded == 'Y')
          {
             noerror = 0;
          } 
          
          if(noerror == 0 )
          {
            this.makeitdisable = true; //remove comment
            this.Progressmsg = 'Validating voters...';
            this.showloadingmsg = true;
            this.showerrorgmsg  = false;
            let formData = new FormData();
            formData.append('eid', this.data.id);
            formData.append('election_trans_id', this.election_trans);
            formData.append('voters', this.voters);
            formData.append('identities', this.identitiesselected);
            
            Vue.axios.post('/save-election-voters', formData, 
            {  headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => 
            {
              this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            },
            }).then(response => 
            {
              if(response.status)
              {
                //this.jobId = response.data.job_id;
                //this.startPolling(); // now before this we need to check data
                this.jobId = response.data.job_id;
                this.processPolling();
              } 
            }).catch(error => {
                console.log(error);
                this.makeitdisable = false;
            })  
          }
    },
    processPolling() {
      this.interval = setInterval(() => {
        if (!this.jobId) return;

        Vue.axios.get(`/voter-progress/${this.jobId}`).then(res => {
          if (res.data) {
            this.uploadprogressvalue = res.data.progress;
            if (res.data.status === 'completed') 
            {
              this.uploadprogressvalue = 0;
              this.Progressmsg = 'Uploading voters...';
              clearInterval(this.interval);
              this.jobId = res.data.job_id;
              this.startPolling();
            }
            else if(res.data.status === 'stopped')
            {
               this.jobId = 0;
               this.identitiesselected = [];
               this.identities = [];
               this.votersfile = '';
               this.duplicateData = res.data.data;
               this.duplicateDataHeader = res.data.head;
               this.makeitdisable = false;
               clearInterval(this.interval);
            }
          }
        });
      }, 2000);
    },
    startPolling() {
      this.interval = setInterval(() => {
        if (!this.jobId) return;

        Vue.axios.get(`/job-progress/${this.jobId}`).then(res => {
          if (res.data) {
            this.uploadprogressvalue = res.data.progress;
            if (res.data.status === 'completed') 
            {
              clearInterval(this.interval);
              this.$router.push({ name: "electiondashboard" });
            }
          }
        });
      }, 2000);
    },
   triggerFileSelect() {
      this.$refs.candidateInput.click();
    },
  }
};
</script>
<style scoped>
.step-form-container {width: 55%;margin: 40px auto;padding: 30px;background: #fff;border-radius: 10px;box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);}
.progress-bar {background-color: #ddd;height: 6px;border-radius: 3px;margin-bottom: 20px;overflow: hidden;}
.progress-bar-inner {background-color: #4caf50;height: 100%;transition: width 0.4s ease-in-out;}
/* Step Content */
.step-content {padding: 20px;}
.fade-enter-active, .fade-leave-active {transition: opacity 0.5s ease-in-out;}
.fade-enter{opacity: 0;}
.fade-leave-to{opacity: 0;}
h2 {font-size: 22px;color: #333; margin-bottom: 15px;}
input, textarea {width: 80%;padding: 10px;margin: 10px 0;border: 1px solid #ccc;border-radius: 5px;font-size: 16px;outline: none;}
textarea{resize: none;height: 80px;}
/* Buttons */
.buttons{margin-top: 20px; text-align: center;}
.btn{padding: 12px 20px;font-size: 16px;border-radius: 5px;border: none;cursor: pointer;transition: 0.3s ease-in-out;box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);}
.back {background-color: #ff7043;color: white;margin-right: 10px;}
.next {background-color: #4caf50;color: white;}
.back:hover {background-color: #d84315;}
.next:hover {background-color: #388e3c;}
/* Custom Button */
.custom-btn {background-color: #008cba;color: white;padding: 12px 20px;border: none;border-radius: 5px;cursor: pointer;margin-top: 20px;transition: 0.3s;}
.custom-btn:hover {background-color: #005f73;}
/* my own*/
.myrows{display: flex; margin-bottom: 15px; align-items: center;}
.myrows > div{width: 48%; margin-right: 2%;}
.myrows .inner-inner-flex{display: flex;align-items: center;}
.myrows .inner-inner-flex > div{width: 30%; text-align: left;}

.myrow{display: flex; margin-bottom: 15px; align-items: center;}
.myrow > div{width: /*48%*/35%; /*margin-right: 2%;*/}
.myrow > div:first-child{margin-right: 2%;}
.myrow > div.secondchild{width: 100%;}
.difflex{display: flex;align-items: center;justify-content: center;}
.difflex > div{width: 96%;}
.difflex > div:nth-child(2){width: 46%;}
.myrow .inner-inner-flex{display: flex;align-items: center;}
.myrow .inner-inner-flex > div{width: 30%; text-align: left;}
.myrow.makedif > div:nth-child(1){width: 25%; align-items: center; text-align: left;}
.myrow.makedif > div:nth-child(2){width: 54%; text-align: left;}
.errorclass.txtleft{text-align: left;}
.template-imgs {display: flex;flex-wrap: wrap;gap: 10px;justify-content: center;}
.temp-img-wrapper {display: flex;flex-direction: column;align-items: center;justify-content: center;width: 200px;border: 1px solid #ccc;padding: 10px;border-radius: 8px;position: relative;background: white;}
.temp-img {width: 100%;cursor: pointer;}
.temp-img img {max-width: 100%; max-height: 100%; object-fit: contain; }
.deletebtn {cursor: pointer;color: red;font-size: 20px;margin-top: 5px;text-align: center;}
.temp-img.clicked { border-color: #007bff; transform: scale(1.05); }
.temp-img.clicked img {border: 2px solid #007bff; background-color: rgba(0, 123, 255, 0.1); }
.upload-area-voters{width: 300px;min-height: 200px; background-image: url('../assets/upload.png');background-size: cover;background-position: center;display: flex;align-items: center;justify-content: center;color: white;cursor: pointer;border: 2px dashed #ccc;text-align: center;transition: background-color 0.2s;flex-direction: column;margin: auto}
.upload-area-voters.drag-over {background-color: rgba(0, 0, 0, 0.5); border-color: #fff;}
.upload-area {width: 300px;min-height: 200px; background-image: url('../assets/upload.png');background-size: cover;background-position: center;display: flex;align-items: center;justify-content: center;color: white;cursor: pointer;border: 2px dashed #ccc;text-align: center;transition: background-color 0.2s;flex-direction: column;margin: auto}
.upload-area.drag-over {background-color: rgba(0, 0, 0, 0.5); border-color: #fff;}
.delete-btn {position: absolute;top: 2px;right: 2px;background-color: rgba(255, 0, 0, 0.7);color: white;border: none;border-radius: 50%;width: 20px;height: 20px;font-size: 16px;line-height: 16px;cursor: pointer;display: flex;align-items: center;justify-content: center;}
.custom-progress {position: absolute;width: 100%;top: 0;left: 0;}
.myrowimgs { display: flex; align-items: center;margin-top: 15px; margin-bottom: 10px; flex-wrap: wrap;}
.saveTemplate{padding: 15px; border: 1px solid #666363; width: 300px; background: #fff; margin: auto; text-align: center;}
.sidebarnew{flex-basis: 20%;height: 790px; overflow-y: scroll; padding: 5px; position: absolute; top:1%; left: 0; width: 20%;}
.sidebarnewright{flex-basis: 20%;height: 790px; overflow-y: scroll; padding: 5px; position: absolute; top:1%; right: 0; width: 20%;}
.errorclass{color: red; font-size: 12px; margin-top: 3px;}
.identitieslist{height: 180px; overflow-y: scroll; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; padding: 10px; border-radius: 10px;}
.smallfont{font-size: 13px;}
.removemg{margin-bottom:0;}
.redtext{color:red;}
.file-label {
  background-color: #666666; /* Button color */
  color: white;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  display: inline-block;
}

.file-label:hover {
  background-color: #666666; /* Hover color */
}
.makeborder{border: 1px solid #9e9e9e; padding: 10px; border-radius: 5px; cursor: pointer;}
.smtext a{font-size: 15px;}
.prgbar{width: 50%; margin: auto; text-align: center; font-weight: bold;}
.makemebig{font-size: 22px;}
.makeseperate {
    display: block;
}
.halfscreen {
    width: 50%;
    display: inline-block;
    text-align: center;
}
@media(max-width: 767px){
   .step-form-container{width: 98%;}
   ::v-deep(.v-input--radio-group__input) {
     display: block;
   }
    .myrows,.myrow {
    flex-direction: column; 
    align-items: stretch;   
    margin-bottom: 0px;
  }

  .myrows > div{
    width: 100%; 
    margin-bottom: 10px;           
  }
  .step-content{padding: 0;}
  .myrow.makedif > div:nth-child(1),.myrow.makedif > div:nth-child(2){width: 100%; margin-bottom: 10px;}
  .cpicker{width: 100%;    height: 40px;}
  .sidebarnew{display: none;}
}
</style>
<style>
.diffchecks.v-input--selection-controls{margin-top: 0;}
</style>